// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aeonik_fc3e9a', '__aeonik_Fallback_fc3e9a', system-ui"},"className":"__className_fc3e9a","variable":"__variable_fc3e9a"};